import { io } from "socket.io-client";
import { getToken } from "./storageController";

// Base URL
const API_BASE = process.env.REACT_APP_BACKEND_URL;

let presenceSocket = null;

/**
 * Extracts the origin from a URL string
 * @param {string} url - URL to parse
 * @returns {string} Origin or original URL if parsing fails
 */
function getSocketBaseUrl(url) {
  try {
    return new URL(url).origin;
  } catch {
    console.warn("Could not parse API_BASE URL, using:", url);
    return url;
  }
}

/**
 * Creates and returns a presence socket connection
 * @param {string} [jwt] - Optional JWT token (will use stored token if not provided)
 * @returns {Socket} Socket.IO socket instance
 */
export function createPresenceSocket(jwt) {
  const token = jwt || getToken();

  if (!token) {
    console.warn("No JWT token available for presence socket connection");
    return null;
  }

  // Disconnect existing socket if any
  if (presenceSocket) {
    presenceSocket.disconnect();
    presenceSocket = null;
  }

  const socketBaseUrl = getSocketBaseUrl(API_BASE);

  presenceSocket = io(`${socketBaseUrl}/presence`, {
    path: "/socket.io",
    transports: ["websocket"],
    auth: { token },
    extraHeaders: { Authorization: `Bearer ${token}` },
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  return presenceSocket;
}

/**
 * Get the current presence socket instance
 * @returns {Socket|null} Current socket instance or null
 */
export function getPresenceSocket() {
  return presenceSocket;
}

// Disconnect the presence socket
export function disconnectPresenceSocket() {
  if (presenceSocket) {
    presenceSocket.disconnect();
    presenceSocket = null;
  }
}

/**
 * Check if presence socket is connected
 * @returns {boolean} Connection status
 */
export function isPresenceSocketConnected() {
  return presenceSocket?.connected || false;
}
